var _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.72484 23.8006C7.10627 19.1059 8.78928 13.1774 13.4839 10.5588C18.1786 7.94025 24.1072 9.62326 26.7257 14.3179C27.9732 16.5544 28.2444 19.0708 27.6789 21.3761L29.5368 23.234C30.7114 20.0468 30.5395 16.3851 28.7551 13.186C25.5114 7.3705 18.1675 5.28568 12.352 8.52941C6.53651 11.7731 4.4517 19.1171 7.69543 24.9326C10.9392 30.748 18.2831 32.8328 24.0986 29.5891C24.5423 29.3416 24.9644 29.0702 25.364 28.7774L23.6965 27.11C23.462 27.269 23.2187 27.4191 22.9666 27.5597C18.2719 30.1783 12.3434 28.4953 9.72484 23.8006Z",
    fill: "#444444"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 9.49182,
    height: 2.32375,
    transform: "matrix(0.707107 0.707107 0.707107 -0.707107 26.5312 26.7305)",
    fill: "#444444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.93f07a443aee901610dda02b0d8db206.svg";
export { ForwardRef as ReactComponent };